import { Store } from '../store/types';
import type { SponsoredBrandDTO } from '../types/sponsored-brands';
import { FETCH_SPONSORED_BRANDS, SPONSORED_BRANDS_RESET } from '../actions';
import { getSponsoredBrands } from '../api';

export type SponsoredBrandsStore = {
  sponsoredBrands: {
    brands: SponsoredBrandDTO | null;
    loading: boolean;
    error: boolean;
  };
};

const initialState: SponsoredBrandsStore = {
  sponsoredBrands: {
    brands: null,
    error: false,
    loading: false,
  },
};

export const sponsoredBrands = (store: Store) => {
  store.on('@init', () => initialState);

  store.on(FETCH_SPONSORED_BRANDS.init, (_, props) => {
    const { apiKey, requestID, orchestratorHost, useCredentials } = store.get();

    store.dispatch(FETCH_SPONSORED_BRANDS.request, true);

    return getSponsoredBrands(
      { ...props },
      {
        orchestratorHost,
        useCredentials,
        apiKey,
        requestID,
      },
    )
      .then((data) => store.dispatch(FETCH_SPONSORED_BRANDS.success, data))
      .catch(() => store.dispatch(FETCH_SPONSORED_BRANDS.failure, true));
  });

  store.on(FETCH_SPONSORED_BRANDS.request, (state) => ({
    sponsoredBrands: {
      ...state.sponsoredBrands,
      loading: false,
      error: false,
    },
  }));

  store.on(FETCH_SPONSORED_BRANDS.success, (_state, data: SponsoredBrandDTO) => ({
    sponsoredBrands: {
      brands: data,
      loading: false,
      error: false,
    },
  }));

  store.on(FETCH_SPONSORED_BRANDS.failure, () => ({
    sponsoredBrands: {
      brands: null,
      loading: false,
      error: true,
    },
  }));

  store.on(SPONSORED_BRANDS_RESET, (state) => {
    if (state.sponsoredBrands.brands !== null) {
      return {
        sponsoredBrands: {
          brands: null,
          loading: state.sponsoredBrands.loading,
          error: state.sponsoredBrands.error,
        },
      };
    }

    return state;
  });
};
